import {SurveyCreationModalProps, TintometerServiceOption} from "./types";
import {useState} from "react";
import Modal from "@ui-components/Modal";
import Button from "@ui-components/Button";
import {FormattedMessage} from "react-intl";

export const SurveyCreationModal = ({
  onConfirm,
  onExit,
  options,
  loading,
  submitting,
}: SurveyCreationModalProps) => {

  const [selected, setSelected]
    = useState<TintometerServiceOption | null>(options.length > 0 ? options[0] : null);

  return (
    // @ts-ignore
    <Modal onExit={onExit}>
      <div className={"flex flex-col gap-10"}>
        <h3 className="font-semibold text-2xl text-am-700">
          <FormattedMessage id="choose_collection" defaultMessage="Scegli collezione" />
        </h3>
        <div className={"max-w-max flex flex-row gap-3 flex-wrap"}>
          {options.map(option => (
            <div key={option.id} className={"flex flex-row items-start justify-start border border-gray-50 rounded shadow-lg gap-5 p-5 flex-1"}>
              <input
                type={"radio"}
                name={option.id.toString()}
                checked={selected?.id === option.id}
                onChange={() => {
                  setSelected(option);
                }}
                className={"text-black-500 ring-black-500 focus:ring-2 focus:ring-black-500 h-4 w-4 cursor-pointer"}
              />
              <div className={"flex flex-col gap-2 items-start justify-start -mt-1"}>
                <p className={"text-lg font-semibold leading-tight text-am-700"}>
                  {option.title}
                </p>
                {
                  !!option.description
                    ? <p className={"text-am-700"}>{option.description}</p>
                    : <p className={"text-gray-400"}>
                      <FormattedMessage id={"no_description"} defaultMessage={"Nessuna descrizione disponibile"} />
                    </p>
                }
              </div>
            </div>
          ))}
        </div>
        <div className="mt-8">
          <Button
            full
            disabled={!selected}
            onClick={() => onConfirm(selected!)}
            submitting={loading || submitting}
          >
            <FormattedMessage id={"create"} defaultMessage={"Crea"} />
          </Button>
        </div>
      </div>
    </Modal>
  )
}